import * as Auth from "~/auth";
import $ from "jquery";
import { userInfo, getApi } from "~/auth";
import * as validation from "~/utils/validation";
import { Form } from "~/components/Form";
import { t } from "~/hooks/useI18n";
import { subscribeNewsletterNoConfirm, unsubscribeNewsletter } from "~/mailup";
import { ConsensiHelper } from "~/services/ConsensiHelper";

export class ConsensiForm extends Form {
    private _userInfo: Auth.UserInfo = {} as Auth.UserInfo; 
    private _onCheckboxChange: () => void;
    private _onAnnullaClick: () => void;
    
    constructor(formId: string) {
        super(formId);
        
        // Bind dei metodi al contesto corrente
        this._onCheckboxChange = this.handleCheckboxChange.bind(this);
        this._onAnnullaClick = this.handleAnnullaClick.bind(this);
        
        this.useLoader(async () => this.load());
        this.onSave(async () => this.save());
    }
    
    private async load() : Promise<void> {
        this._userInfo = await userInfo(true);
    }
    
    addValidation(): void {
        // Validator per i consensi obbligatori
        const consensoValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const isRequired = inputElement.hasAttribute('required');
            const isChecked = inputElement.checked;
            
            return {
                ok: !isRequired || isChecked,
                error: (!isRequired || isChecked) ? "" : t("validation.required")
            };
        };
        
        // Applica la validazione a tutte le checkbox dei consensi
        $(this.theForm).find('input[type="checkbox"].form-check-input').each(function() {
            const checkbox = this as HTMLInputElement;
            const elementId = checkbox.id;
            
            if (elementId && checkbox.hasAttribute('required')) {
                // Imposta il validator per questo consenso
                validation.setValidatorOn('change', elementId, consensoValidator);
            }
        });
    }

    bind(): Promise<void> {
        // Nascondi la pulsantiera inizialmente
        this.hidePulsantiera(); 
        
        // Registra i listener sulle checkbox dei consensi
        $(this.theForm).find('input[type="checkbox"].form-check-input').on('change', this._onCheckboxChange);
        
        // Registra il listener sul pulsante Annulla
        $('#btnAnnullaPrivacy').on('click', this._onAnnullaClick);
        
        return Promise.resolve(undefined); 
    }

    clear(): Promise<void> {
        return Promise.resolve(undefined);
    }
    
    private handleCheckboxChange(): void {
        // Mostra la pulsantiera quando una checkbox viene modificata
        this.showPulsantiera();
    }
    
    private handleAnnullaClick(): void {
        // Nascondi eventuali messaggi di errore
        this.errorMessage.hideError();
        
        // Ripristina i valori originali e nascondi la pulsantiera
        this.fill();
        this.hidePulsantiera();
    }
    
    private async save(): Promise<void> {
        // ✅ Raccogli i consensi con anche il codice
        // const consensi: Array<{ consensoId: number, codice: string, checked: boolean }> = [];

        // $(this.theForm).find('input[type="checkbox"].form-check-input').each(function () {
        //     const checkbox = $(this);
        //     const consensoId = parseInt(checkbox.attr('data-privacy-id') || '0');
        //     const codice = checkbox.attr('data-codice') || '';  // ✅ AGGIUNGI QUESTO
        //     const checked = checkbox.prop('checked') as boolean;

        //     consensi.push({
        //         consensoId: consensoId,
        //         codice: codice,      // ✅ AGGIUNGI QUESTO
        //         checked: checked
        //     });
        // });

        // // Chiama l'endpoint PUT /privacy/consensiUtente
        // await getApi().fetchWithAuth("PUT /privacy/consensiUtente", {
        //     body: JSON.stringify({
        //         consensi: consensi.map(c => ({
        //             consensoId: c.consensoId,
        //             checked: c.checked
        //         }))
        //     })
        // });

        // // ✅ Cerca il consenso NEWS nell'array
        // const consensoNews = consensi.find(c => c.codice === "NEWS");

        // if (consensoNews) {
        //     try {
        //         // ✅ Recupera userInfo (assicurati che sia disponibile nel contesto)

        //         if (!this._userInfo || !this._userInfo.email) {
        //             console.warn("⚠️ Email utente non disponibile per gestione newsletter");
        //             return;
        //         }

        //         if (consensoNews.checked) {
        //             // ✅ ISCRIZIONE alla newsletter
        //             console.info("✅ Iscrizione newsletter per:", this._userInfo.email);

        //             await subscribeNewsletterNoConfirm(
        //                 window.ATP_ListID_Newsletter,
        //                 window.ATP_GroupId_Registrazione,
        //                 this._userInfo.email
        //             );

        //             console.info("✅ Iscrizione newsletter completata");

        //         } else {
        //             // ✅ DISISCRIZIONE dalla newsletter
        //             console.info("✅ Disiscrizione newsletter per:", this._userInfo.email);

        //             await unsubscribeNewsletter(
        //                 window.ATP_ListID_Newsletter,
        //                 this._userInfo.email
        //             );

        //             console.info("✅ Disiscrizione newsletter completata");
        //         }

        //     } catch (error) {
        //         console.error("❌ Errore gestione newsletter:", error);
        //     }
        // }

        await ConsensiHelper.saveAndSyncConsensi(
            this.theForm,
            this._userInfo.email || ""
        );
        
        // Se arriviamo qui, il salvataggio è andato a buon fine
        // Nascondi la pulsantiera
        this.hidePulsantiera();
        
        // Ricarica i dati aggiornati
        await this.reload();
    }
    
    private showPulsantiera(): void {
        $('#btnAnnullaPrivacy, #btnSalvaPrivacy').parent().removeClass('d-none');
    }
    
    private hidePulsantiera(): void {
        $('#btnAnnullaPrivacy, #btnSalvaPrivacy').parent().addClass('d-none');
    }

    fill(): Promise<void> {
        const consensi = this._userInfo.consensi || [];
        
        // Valorizza le checkbox in base al campo "concesso" e al "codice" dell'oggetto
        consensi.forEach(item => {
            console.info(item);
            const checkbox = $(`input[name="${item.codice}"]`);
            if (checkbox.length > 0) {
                checkbox.prop('checked', item.concesso);
                
                // Aggiungi data attribute per l'id del consenso
                checkbox.attr('data-privacy-id', item.id.toString()); 
            }
        });
        
        return Promise.resolve();
    }

    unbind(): Promise<void> {
        // Rimuovi i listener dalle checkbox
        $(this.theForm).find('input[type="checkbox"].form-check-input').off('change', this._onCheckboxChange);
        
        // Rimuovi il listener dal pulsante Annulla
        $('#btnAnnullaPrivacy').off('click', this._onAnnullaClick);
        
        return Promise.resolve(undefined);
    }
    
}